module.exports = __webpack_public_path__ + "img/contact-1.0e97863a.png";